"use strict";

import axios from "axios";
import Qs from "qs";
import { sha256 } from 'js-sha256';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const CancelToken = axios.CancelToken;
let cancel;


let config = {
    baseURL: process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_DEV_API_URL || 'http://192.168.51.1' : "",
    // xsrfCookieName:'uuid'
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};


let isLogouted = false // 是否退出

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    if(!isLogouted){
        config.cancelToken = new CancelToken(function executor(c) {
            cancel = c;
        })
    }
    if(process.env.NODE_ENV !== 'production')
    {
        if(!config.data) config.data = {} 
        config.data.apiEnv = 'dev';
    }
    if (config.method === 'post')
    {
        let auth_token,en_data,key;
        if(config.headers["Content-Type"] != "multipart/form-data")
        {// 非文件上传
            if(config.url != '/JSONAPI')
            {// 非 json api 需要转为 字符串
                config.data = Qs.stringify(config.data);
                en_data = config.data || 'fiberhome'
            }
            else
            {
                if(config.data.cmdType && config.data.cmdType === 'SET_WEB_LOGIN')
                {// 登录请求 不需要设置 X-XSRF-TOKEN
                    isLogouted = false
                    return config;
                }
                // 把对象转为未字符串
                en_data = JSON.stringify(config.data) || 'fiberhome'
            }
            
            key = cookie.getItem('uuid') || 'qwertyuiopasdfghjklzxcvbnm'
            if(!key)
            {
                logout(function () {
                    $vm.$notify.error({
                        title: 'Error',
                        message: 'Access permission error! Please login again or restart the device and try again.'
                    })
                })
            }

            auth_token = sha256.hmac(key,en_data)
            config.headers.post['X-XSRF-TOKEN'] = auth_token
        }      
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if(response.data)
    {
        if(response.data.webTimeOut )
        {
            logout(function () {
                $vm.$notify.error({
                    title: 'Error',
                    message: 'You have not operated for a long time, the login information is invalid! Please login again!'
                })
            })
            
        }
    }
    return response;
  },
  function(error) {
    // Do something with response error
    if(error.response && error.response.status >= 400 )
    {
        logout(function () {
            $vm.$notify.error({
                title: 'Error',
                message: 'Access rights are wrong! Please login again or restart the device and try again.'
            })
        })
    }

    return Promise.reject(error);

  }
);


export default _axios;


function logout(msgcallback) {
    if(!isLogouted && $vm.$route.path !== '/')
    {
        cookie.clear()
        $vm.$router.push('/')
        cancel()
        isLogouted = true
        msgcallback()
    }
}